import { useInfiniteQuery, useQuery } from 'react-query';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';
import { NbsListRequest } from './Nbs.types';
import { nbsByCode, nbsList } from './Nbs.service';

const NBS_LIST_KEY = 'nbs/list';
const NBS_DETAIL_KEY = 'nbs/detail';

export function useNbs(params?: NbsListRequest, enabled = true) {
  const cache = queryClient.getQueryData([NBS_LIST_KEY, params]);

  return useInfiniteQuery(
    [params, params],
    ({ pageParam }) => {
      const req: NbsListRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return nbsList(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
      enabled: enabled && !cache,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useNbsByCode(nbsCode?: string) {
  return useQuery([NBS_DETAIL_KEY, nbsCode], () => nbsByCode(nbsCode), {
    enabled: !!nbsCode,
    onError(error) {
      notificationError(error);
    },
  });
}
